var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clear-layout"},[_c('main',{staticClass:"content"},[_vm._t("default")],2),_c('notifications',{attrs:{"position":"top right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }